<div class="sign-in">
  <!-- Theme toggle: fixed top-right, visible on all viewports -->
  <app-theme-toggle class="sign-in__theme-toggle" />

  <!-- Panneau de marque, directement sur le beige de la page (MOKA-356) : rien qui détourne
       l'attention du formulaire, « organisation » en orange ressort sur le fond clair. -->
  <div class="sign-in__left">
    <div class="sign-in__branding">
      <p class="sign-in__brand">mokah<span class="plus">+</span></p>
      <h1 class="sign-in__headline">Réveillez votre <span class="sign-in__accent">organisation</span>.</h1>
      <p class="sign-in__tagline">Votre espace de travail collaboratif, chaleureux comme un café.</p>

      <ul class="sign-in__features">
        @for (feature of features; track feature.title) {
          <li class="sign-in__feature">
            <span class="sign-in__feature-icon">
              <ng-icon [name]="feature.icon" size="18"></ng-icon>
            </span>
            <span class="sign-in__feature-text">
              <strong class="sign-in__feature-title">{{ feature.title }}</strong>
              <span class="sign-in__feature-detail">{{ feature.detail }}</span>
            </span>
          </li>
        }
      </ul>

      <!-- Argument d'entrée : essai gratuit sans engagement -->
      <div class="sign-in__trial">
        <ng-icon name="iconoirCreditCardSlash" size="20" class="sign-in__trial-icon"></ng-icon>
        <span class="sign-in__trial-text">
          <strong>14 jours d'essai gratuit</strong>
          <span>Sans carte bancaire requise</span>
        </span>
      </div>
    </div>
  </div>

  <!-- Formulaire, sur le fond orangé (MOKA-356) -->
  <div class="sign-in__right">
    <div class="sign-in__right-center">
      <div class="sign-in__form-wrapper">
        <!-- Tab switcher -->
        <div class="pill-tabs sign-in__tabs" role="tablist" aria-label="Connexion ou inscription">
          <button
            type="button"
            class="pill-tab sign-in__tab"
            (click)="activeTab.set('signIn')"
            role="tab"
            [attr.aria-selected]="activeTab() === 'signIn'"
          >
            <ng-icon name="iconoirLogIn" size="15"></ng-icon>
            Connexion
          </button>
          <button
            type="button"
            class="pill-tab sign-in__tab"
            (click)="activeTab.set('signUp')"
            role="tab"
            [attr.aria-selected]="activeTab() === 'signUp'"
          >
            <ng-icon name="iconoirUserPlus" size="15"></ng-icon>
            Inscription
          </button>
        </div>

        <!-- Form header -->
        <div class="sign-in__form-header">
          <!-- Koffi dans l'espace libre à droite du titre (MOKA-358) : « salut » à la connexion, « guide » à l'inscription
               (deux images : changer d'onglet rejoue son entrée) -->
          @if (activeTab() === 'signIn') {
            <img class="sign-in__mascot" [src]="mascots.salut" alt="" width="112" height="112" aria-hidden="true" />
          } @else {
            <img class="sign-in__mascot sign-in__mascot--guide" [src]="mascots.guide" alt="" width="112" height="112" aria-hidden="true" />
          }

          @if (activeTab() === 'signIn') {
            <p class="sign-in__eyebrow">Connexion</p>
            <h2 class="sign-in__form-title">
              <span class="sign-in__title-desktop">Bon retour <span class="sign-in__accent">parmi nous</span></span>
              <span class="sign-in__title-mobile">Bienvenue sur mokah<span class="sign-in__accent">+</span></span>
            </h2>
            <p class="sign-in__form-subtitle">Identifiez-vous pour accéder à votre espace</p>
          } @else {
            <p class="sign-in__eyebrow">Inscription</p>
            <h2 class="sign-in__form-title">Commencez <span class="sign-in__accent">gratuitement</span></h2>
            <p class="sign-in__form-subtitle">14 jours d'essai, sans carte bancaire</p>
          }
        </div>

        <!-- Form content -->
        <div class="sign-in__form-content">
          @if (activeTab() === 'signIn') {
            @if (authService.profile === null) {
              <app-login-by-email [prefillEmail]="prefillEmail()"></app-login-by-email>
            }
          } @else {
            <app-sign-up-flow [verifyEmail]="verifyEmail()" [prefillEmail]="prefillEmail()"></app-sign-up-flow>
          }
        </div>

      </div>
    </div>

    <footer class="sign-in__footer">
      <a routerLink="/documents/privacy-policy">Confidentialité</a>
      <a routerLink="/documents/legal-notices">Mentions légales</a>
      <a routerLink="/documents/terms">CGU</a>
      <a routerLink="/documents">Tous nos documents légaux</a>
      <a href="https://mokahplus.com" target="_blank" rel="noopener">mokahplus.com</a>
      @if (gtm.available()) {
        <button type="button" class="sign-in__cookies" (click)="gtm.reopen()">Gérer les cookies</button>
      }
    </footer>
    <app-consent-banner />
  </div>
</div>
